import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Navigation, Footer, TopBar } from './components';
import { ProtectedRoute } from './components/common';
import { HomePage, FreeEstimate, BookNow, MyBooking, Privacy, Terms, AdminDashboard, NotFound } from './pages';
import { ROUTES } from './constants';
import './App.css';

// 动态更新 HTML lang 属性
const LanguageUpdater: React.FC = () => {
  const { i18n } = useTranslation();
  
  useEffect(() => {
    document.documentElement.lang = i18n.language;
  }, [i18n.language]);
  
  return null;
};

// 内部路由组件
const AppRoutes: React.FC = () => {
  const location = useLocation();
  const isAdmin = location.pathname.startsWith('/admin');

  // Admin 页面独立渲染
  if (isAdmin) {
    return (
      <Routes>
        <Route
          path="/admin"
          element={
            <ProtectedRoute requireAdmin>
              <AdminDashboard />
            </ProtectedRoute>
          }
        />
      </Routes>
    );
  }

  // 普通页面带导航
  return (
    <div className="app">
      <TopBar />
      <Navigation />
      <main className="main-content">
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/free-estimate" element={<FreeEstimate />} />
          <Route path="/book-now" element={<BookNow />} />
          <Route path="/my-booking" element={<MyBooking />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </main>
      <Footer />
    </div>
  );
};

const App: React.FC = () => {
  return (
    <BrowserRouter>
      <LanguageUpdater />
      <AppRoutes />
    </BrowserRouter>
  );
};

export default App;
